<div class="metadata-area">
  <appMetadataWidget [data]="data"></appMetadataWidget>
  <app-metadata-field [data]="data"></app-metadata-field>
  <div [formGroup]="form" id="form">
    <div class="metadata-block" fxLayout="column">
      <label class="metadata-key" for="label" title="{{ data.id }}">Label</label>
      <div class="metadata-input-block">
        <mat-icon matPrefix class="metadata-input-icon">mode_edit</mat-icon>
        <input tabindex="1" formControlName="label" class="metadata-input-field" id="label" type="text" fxFlex="flex-grow"
          placeholder="{{ data.label }}" [(ngModel)]="data.label" />
      </div>
      <div *ngIf="form?.get('label')?.hasError('maxlength')" class="error-msg">Max 30 characters are allowed</div>
    </div>
    <div class="metadata-column-divider" fxLayout="column"></div>
    <div class="metadata-block" fxLayout="column">
      <label class="metadata-key" for="desc">Description</label>
      <div class="metadata-input-block">
        <mat-icon matPrefix class="metadata-input-icon">mode_edit</mat-icon>
        <input tabindex="1" formControlName="description" class="metadata-input-field" fxFlex="flex-grow" id="desc" type="text"
          [(ngModel)]="data.description" />
      </div>
      <div *ngIf="form?.get('description')?.hasError('maxlength')" class="error-msg">Max 100 characters are allowed
      </div>
    </div>
    <!-- Comments -->
    <div class="metadata-block" fxLayout="row wrap">
      <div class="metadata-title">Comment</div>
    </div>
    <div class="metadata-block" fxLayout="row wrap">      
      <div class="metadata-properties">
        <div class="metadata-key" for="commentKey" title="{{ data.id }}">Key</div>
        <div class="metadata-input-block">
          <mat-icon matPrefix class="metadata-input-icon">mode_edit</mat-icon>
          <input tabindex="1" fxFlex="flex-grow" formControlName="commentKey" class="metadata-input-field" id="commentKey" type="text"
            placeholder="{{ data.commentKey }}" (change)="onChangeCommentKey($event)" />
        </div>
        <div *ngIf="form?.get('heading')?.hasError('maxlength')" class="error-msg">Max 30 characters are allowed</div>
      </div>
    </div>   
    <div class="metadata-block" fxLayout="row wrap">
      <div class="metadata-properties" fxLayout="row wrap">
        <div class="metadata-key" >Comment Condition&nbsp;&nbsp;</div>
        <div class="custom-control custom-checkbox cursor-pointer" *ngFor="let item of commentFieldGroup; let i = index">
            <input class="cursor-pointer" type="checkbox" id={{item.label}} [checked]="item.checked" (change)="changeCommentStatus(item,$event,i)"/>&nbsp;
            <label for={{item.label}} class="cursor-pointer">{{item.label}}&nbsp;&nbsp;</label>
        </div>
      </div>
    </div>
    <div class="metadata-block" fxLayout="row wrap">
      <div class="metadata-properties" fxLayout="row nowrap">
        <label class="metadata-key" for="otherFlag">Conditional Comment Optional</label>
        <input tabindex="1" class="metadata-value" id="commentFieldOnOptional" 
          type="checkbox" 
          formControlName="commentFieldOnOptional"
          (change)="onChangeCommentFieldOnOptional($event)" />
      </div>
    </div>
  </div>
  <!-- Options -->
  <div id="optionsBlock" class="metadata-block">
    <div class="metadata-title">Options</div>
    <div class="metadata-properties" fxLayout="row nowrap">
      <mat-label class="metadata-key">Add/Clear</mat-label>
      <button mat-icon-button tabindex="1" class="metadata-button"
        [disabled]="form.get('options')?.value.length >= 20"
        (click)="onAddNewOption()" title="Add">
        <mat-icon class="action-icon">add</mat-icon>
      </button>
      <button mat-icon-button tabindex="1" class="metadata-button" (click)="onClearAllOptions()" title="Clear">
        <mat-icon class="action-icon">delete</mat-icon>
      </button>
    </div>
    <div id="optionCheckbox" [formGroup]="optionCheckbox" class="metadata-properties" fxLayout="row wrap"
      *ngFor="let optionCheckbox of getControls()['controls']; let i = index;">
      <div class="metadata-properties" fxLayout="row nowrap">
        <div class="metadata-key">Label</div>
        <div class="metadata-input-block" fxLayout="row nowrap">
          <mat-icon matPrefix class="metadata-input-icon">mode_edit</mat-icon>
          <input tabindex="1" formControlName="key" class="metadata-input-field metadata-option-label" type="text"
            placeholder="Option label" (change)="onSaveOptions(i)" />
          <div *ngIf="optionCheckbox?.get('key')?.hasError('maxlength')" class="error-msg">Max 35 characters are allowed
          </div>
        </div>
      </div>
      <div class="metadata-properties" fxLayout="row nowrap">
        <div class="metadata-key">Value</div>
        <div class="metadata-input-block" fxLayout="row nowrap">
          <mat-icon matPrefix class="metadata-input-icon">mode_edit</mat-icon>
          <input tabindex="1" formControlName="value" class="metadata-input-field metadata-option-label" type="text"
            placeholder="Option value" (change)="onSaveOptions(i)" />
          <div *ngIf="optionCheckbox?.get('value')?.hasError('maxlength')" class="error-msg">Max 35 characters are
            allowed</div>
          <!-- <div *ngIf="optionCheckbox?.get('value')?.hasError('max')" class="error-msg">Max 3000 is allowed</div> -->
          <div *ngIf="optionCheckbox?.get('value')?.hasError('required')" class="error-msg">* Required</div>
        </div>
        <button mat-button class="metadata-button" (click)="onDeleteOption(i)">Delete</button>
      </div>
    </div>
    <div class="metadata-properties" fxLayout="row nowrap">
      <label><input tabindex="1" class="metadata-key" type="checkbox" [(ngModel)]="data.otherFlag" (change)="setDefaultMaxLength()"/>Other</label>
    </div>
    <div class="metadata-properties" fxLayout="row nowrap">
        <label><input tabindex="1" class="metadata-key" type="checkbox" [(ngModel)]="data.required" />Required</label>
    </div>
    <div class="metadata-properties" fxLayout="row nowrap">
      <label><input tabindex="1" class="metadata-key" type="checkbox" [(ngModel)]="!data.isExtended" />Suffix Option Keys</label>
    </div>
    <div *ngIf="data.otherFlag">
      <label>Max length: </label><input tabindex="1" class="metadata-key-input" type="text"[(ngModel)]="data.otherMaxLength"  />
    </div>
    <div *ngIf="errorMessage !== ''" class="error-msg">{{errorMessage}}</div>
  </div>
  <div>
    <appMetadataTemplate [primitive]="data" [template]="template" (modifiedJsonTemplate)="getModifiedTemplate($event)">
    </appMetadataTemplate>
  </div>
</div>